import React, { useEffect, useState } from "react";
import {
  Container,
  Button,
  Typography,
  Grid,
  InputLabel,
  TextField,
  TextareaAutosize,
  Stack,
  FormControl,
  Select,
  MenuItem,
} from "@common-ui/ui";
import { Section } from "../components";
import { AddCircle } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { workInstructionSlice } from "../../../../reducers/workReducer";
import { Divider } from "@mui/material";
import { useParams, useHistory } from "react-router-dom";
import { getProcedure, updateProcedure } from "../../../../services";
export const EditPanel = () => {
  // const [sections, setSections] = React.useState([]);
  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const dispatch = useDispatch();
  // dispatch(workInstructionSlice.actions.clearWorkInstruction());
  const workInstruction = useSelector((state) => state.workInstruction);

  console.log("workInstruction", workInstruction);
  const [defaultData, setDefaultData] = useState({});
  const sections = workInstruction.items;

  const handleRemoveSection = (sectionId) => {
    dispatch(workInstructionSlice.actions.removeSection({ sectionId }));
  };
  let router = useHistory();
  let params = useParams();

  async function init() {
    try {
      const newData = await getProcedure(
        params.id,
        params.orgId,
        params.serviceTypeId,
        params.serviceOptionId
      );
      console.log("newData", newData);
      const newWorkInstruction = newData?.procedure;
      setDefaultData(newWorkInstruction);
      dispatch(
        workInstructionSlice.actions.setWorkInstruction({
          data: newWorkInstruction,
        })
      );
    } catch (error) {
      alert(error);
    }
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateProcedure(
        workInstruction,
        params.orgId,
        params.serviceTypeId,
        params.serviceOptionId,
        params.id
      );
      alert("Success!");
      router.push(`/procedures`);
    } catch (error) {
      alert(error);
    }
  };
  return (
    <Container maxWidth="md" component="form" onSubmit={handleSubmit}>
      <Typography variant="h3">Details</Typography>
      <Divider sx={{ my: 2 }} />
      <Grid>
        <Grid item md={6} xs={12}>
          <div>
            <InputLabel>Instruction Title</InputLabel>
            <TextField
              sx={{ mt: 1 }}
              size="small"
              fullWidth
              placeholder="Type"
              margin="normal"
              required
              name="title"
              variant="outlined"
              value={workInstruction.title}
              onChange={(e) =>
                dispatch(
                  workInstructionSlice.actions.handleWorkInstruction({
                    name: e.target.name,
                    value: e.target.value,
                  })
                )
              }
            />
          </div>
        </Grid>
        <Grid item md={6} xs={12}>
          <div>
            <InputLabel>Description</InputLabel>
            <TextField
              sx={{ mt: 1 }}
              onChange={(e) =>
                dispatch(
                  workInstructionSlice.actions.handleWorkInstruction({
                    name: "description",
                    value: e.target.value,
                  })
                )
              }
              size="small"
              placeholder="Type"
              fullWidth
              name="description"
              value={workInstruction.description}
              variant="outlined"
            />
          </div>
        </Grid>
        <Grid item md={6} xs={12}>
          <div>
            <InputLabel>Revision</InputLabel>
            <TextField
              sx={{ mt: 1 }}
              onChange={(e) =>
                dispatch(
                  workInstructionSlice.actions.handleWorkInstruction({
                    name: "revision",
                    value: e.target.value,
                  })
                )
              }
              size="small"
              placeholder="Type"
              fullWidth
              name="revision"
              value={workInstruction.revision}
              variant="outlined"
            />
          </div>
        </Grid>
        <Grid item md={6} xs={12}>
          <div>
            <InputLabel>General notes</InputLabel>
            <TextField
              sx={{ mt: 1 }}
              size="small"
              fullWidth
              placeholder="Type"
              margin="normal"
              InputProps={{
                inputComponent: TextareaAutosize,
                inputProps: { minRows: 4 },
              }}
              name="notes"
              variant="outlined"
              onChange={(e) =>
                dispatch(
                  workInstructionSlice.actions.handleWorkInstruction({
                    name: "notes",
                    value: e.target.value,
                  })
                )
              }
              value={workInstruction.notes}
            />
          </div>
        </Grid>
        <Grid item md={6} xs={12}>
          <div>
            <InputLabel>Status</InputLabel>
            <FormControl fullWidth name="na">
              <Select
                sx={{ mt: 1 }}
                onChange={(e) =>
                  dispatch(
                    workInstructionSlice.actions.handleWorkInstruction({
                      name: "status",
                      value: e.target.value,
                    })
                  )
                }
                size="small"
                placeholder="Select"
                name="status"
                variant="outlined"
                value={workInstruction.status}
                // displayEmpty
                // renderValue={() => "Select"}
              >
                <MenuItem value="none" disabled>
                  <em>Select</em>
                </MenuItem>
                {/* <MenuItem value={"IN_PROGRESS"}>In Progress</MenuItem> */}
                <MenuItem value={"DRAFT"}>Draft</MenuItem>
                <MenuItem value={"COMPLETED"}>Published</MenuItem>
              </Select>
            </FormControl>
          </div>
        </Grid>
      </Grid>
      <Divider sx={{ my: 2 }} />
      <Typography variant="h3" sx={{ my: 1 }}>
        Sections
      </Typography>
      {Array.from(sections).map((section, index) => {
        return (
          <Section
            key={section.id}
            sectionId={section.id}
            handleRemoveSection={handleRemoveSection}
            sectionIndex={index}
          />
        );
      })}
      <Button
        onClick={() => dispatch(workInstructionSlice.actions.addSection())}
        startIcon={<AddCircle />}
        variant="outlined"
      >
        Add Section
      </Button>
      <Stack>
        <Divider sx={{ mb: 1, mt: 2 }} />

        <Stack
          direction={{ xs: "column", md: "row" }}
          justifyContent="flex-end"
          spacing={{ xs: 1, md: 2 }}
          sx={{ py: 2 }}
        >
          <div>
            <Button
              color="primary"
              // disabled={formik.isSubmitting}
              fullWidth
              size="large"
              onClick={() => router.goBack()}
              // type="submit"
              variant="text"
            >
              Cancel
            </Button>
          </div>
          <div>
            <Button
              color="primary"
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              disabled={
                JSON.stringify(defaultData) === JSON.stringify(workInstruction)
              }
            >
              Save
            </Button>
          </div>
        </Stack>
      </Stack>
    </Container>
  );
};
